module.exports = __webpack_public_path__ + "static/media/Gotham-Bold.882dd90e.woff";